export const SEARCH_WAIT_ERROR_DELAY = 1 * 1000
export const SEARCH_ERROR_DELAY = 5 * 1000
